
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Search from 'vux/src/components/search/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import { request, setToken } from "../utils/axios";

export default {
directives: {
TransferDom
},
components: {
XHeader,
Actionsheet,
ButtonTab,
ButtonTabItem,
XTable,
Group,
Cell,
CellFormPreview,
CellBox,
Badge,
XTextarea,
Card,
Divider,
Tabbar,
Scroller,
TabbarItem,
Search,
XButton,
XInput,
Datetime,
Toast,
XDialog,
Flexbox,
FlexboxItem,
Loading,
Confirm
},
data() {
return {
showContent004: true,
value1: "2015-11-12",
show3: false,
showContent005: false,
showHideOnBlur: false,
enterFlag: null,
detailData: { visitorList: [] }, //详情信息
input1: "", //单据
documentInfo: [], //单据信息
insertData: [], //进厂信息
outData: [], //出厂信息
dataFlag: "", //判断是进厂信息还是出厂信息
modalList: [], //弹窗内显示的单据信息
Datetime: "请选择进厂的时间",
dateinfo: "",
driverGenderFlag: false,
siteList: [
{ value: "A050", meaning: "内蒙大全一期" },
{ value: "A051", meaning: "内蒙大全二期" },
{ value: "A070", meaning: "内蒙半导体" },
{ value: "A020", meaning: "新疆大全工厂" },
{ value: "A090", meaning: "内蒙研究院" }
], //工厂信息
businessType: [
{ value: "常规类", meaning: "常规类" },
{ value: "施工单位-设备类", meaning: "施工单位-设备类" },
{ value: "施工单位-施工类", meaning: "施工单位-施工类" }
],
appointmentType: [
{ value: "VEHICLE", meaning: "车辆" },
{ value: "UN_VEHICLE", meaning: "非车辆" }
],
sexList: [
{ value: "男", meaning: "男" },
{ value: "女", meaning: "女" }
],
categoryList: [
{ value: 1, meaning: "国一" },
{ value: 2, meaning: "国二" },
{ value: 3, meaning: "国三" },
{ value: 4, meaning: "国四" },
{ value: 5, meaning: "国五" },
{ value: 6, meaning: "国六" }
],

gateSentry: [{ value: "4", meaning: "4号门岗" }],
siteFlag: false, //工厂弹窗
businessTypeFlag: false, //单类型弹窗
appointmentTypeFlag: false, //类型弹窗
gateSentryFlag: false, //门岗弹窗
show2: true,
show4: false,
show5: false,
show6: false,
show7: false,
show8: false,
show9: false,
show9message: "",
enableFlag: true,
message: "",
minDate: "",
hour: "",
minute: "",
followFlag: false, //随行人信息弹窗
followerGenderFlag: false, //随行人性别弹窗
visitorName: "",
visitorGender: "",
visitorPhone: "",
idNumber: "",
visitorList: [],
categoryFlag: false, //排放类别弹窗
secondEditFlag: false, //进出厂事由、备注、出厂物资可编辑状态
firstEditFlag: false, //进出厂事由、备注、出厂物资可编辑状态
insertDisbaleDeleteOutQtyInputFlag: false, //入场物资禁止删除标志  出场物资填写数量
thirdEditFlag: true,
loading: false,
timeout: null
};
},
beforeMount() {
if (this.$route.query.reservationDocId) {
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docsDetail?reservationDocId=${this.$route.query.reservationDocId}`
)
.then(response => {
this.show2 = false;

if (response.data.failed) {
this.message = response.data.message;
this.show7 = true;

return;
}
this.detailData = response.data;
this.detailData.visitorList = response.data.visitorList;
const { reservationDocStatus, vehicleStatus } = this.detailData;


this.firstEditFlag =
(reservationDocStatus === "REFUSED" ||
reservationDocStatus === "TO_APPROVE" ||
reservationDocStatus === undefined ||
reservationDocStatus === "APPROVED") &&
(vehicleStatus === "RESERVED" || vehicleStatus === "IN_MATERIAL_NG")
? false
: true;

this.secondEditFlag =
(reservationDocStatus === "TO_APPROVE" ||
reservationDocStatus === "REFUSED" ||
reservationDocStatus === "ENTERED" ||
reservationDocStatus === "ENTERED_OPERATION") &&
(vehicleStatus === "ENTERED" ||
vehicleStatus === "FIRST_WEIGHT_COMPLETED" ||
vehicleStatus === "SECOND_WEIGHT_COMPLETED" ||
vehicleStatus === "OUT_MATERIAL_NG")
? false
: true;
this.insertDisbaleDeleteOutQtyInputFlag = [
"TO_APPROVE",
"REFUSED",
"ENTERED",
"ENTERED_OPERATION"
].includes(reservationDocStatus)
? true
: false;
this.dateinfo = response.data.estimatedArrivalTime.slice(0, -3);

this.insertData = this.detailData.list.filter(
item => item.reservationMaterialType === "INTO"
);
this.outData = this.detailData.list.filter(
item => item.reservationMaterialType === "OUT"
);
})
.catch(error => {});

this.enableFlag = true;
} else {
this.thirdEditFlag = false;
this.enableFlag = false; 
this.show2 = false;
}

request(
"get",
"/hitf/v2p/rest/invoke/queryLovValueList?lovCode=MATEINOUT_VES"
).then(res => {
this.categoryList = res.data;
});


request(
"get",
"/hitf/v2p/rest/invoke/queryLovValueList?lovCode=DQ_RESERVATION_TYPE"
).then(res => {
this.appointmentType = res.data;
});


request(
"get",
"/hitf/v2p/rest/invoke/queryLovValueList?lovCode=DQ_SITE_CODE"
).then(res => {
this.siteList = res.data;
});

request(
"get",
"/hitf/v2p/rest/invoke/queryLovValueList?lovCode=DQ_GATE_CODE"
).then(res => {
this.gateSentry = res.data;
});

let date = new Date();
let currentDate = new Date().toISOString(); 
this.minDate = currentDate.slice(0, 10);
this.hour = date.getHours();
this.minute = date.getMinutes();
},
methods: {
checkIdcard(value) {
var reg = /^\d{17}(\d|X|x)$/; 
if (reg.test(value)) {
return { valid: true }; 
} else {
return { valid: false, msg: "身份证号码格式错误请检查" }; 
}
},
checkphoneNum(value) {
var reg = /^\d{11}$/; 
if (reg.test(value)) {
return { valid: true }; 
} else {
return { valid: false, msg: "电话号码格式错误" }; 
}
},
driverName(value) {
var reg = /^[\u4e00-\u9fa5]{1,10}$/; 
if (reg.test(value)) {
return { valid: true }; 
} else {
return {
valid: false,
msg: "姓名格式错误请保证没有空格且姓名在10个字符以内"
}; // 验证错误 返回valid:false;
}
},
checkCarCode(value) {
const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/; 
if (reg.test(value)) {
return { valid: true }; 
} else {
return { valid: false, msg: "车牌号格式错误" }; 
}
},
handleChange(data) {
this.enableFlag = data;

},

reAppointment() {
this.enableFlag = false;
this.firstEditFlag = false;

delete this.detailData.reservationDocId;
delete this.detailData.reservationDocNum;
delete this.detailData.estimatedArrivalTime;
delete this.detailData.reservationDocStatus;
delete this.detailData.vehicleStatus;
this.input1 = "";
this.documentInfo = [];
this.insertData = [];
this.outData = [];
this.$forceUpdate();
},
getTitle(title) {
return `<div style="width:100px"><span style="color: red">*</span>${title}:</div>`;
},

changeSite(item) {
this.detailData.siteCode = item.value;
this.detailData.siteCodeMeaning = item.meaning;
this.siteFlag = false;
},

changeBusinessType(item) {
this.detailData.businessType = item.value;
this.detailData.applicant = "";
this.businessTypeFlag = false;
this.documentInfo = [];
this.insertData = [];
this.outData = [];
},

changeAppointmentType(item) {
this.detailData.type = item.value;
this.detailData.typeMeaning = item.meaning;
this.appointmentTypeFlag = false;
},

changeGateSentry(item) {
this.detailData.gate = item.value;
this.detailData.gateMeaning = item.meaning;
this.gateSentryFlag = false;
},


changeDriverGender(item) {
this.detailData.driverGender = item.meaning;
this.driverGenderFlag = false;
},
toggle() {
this.showContent004 = !this.showContent004;
},

headDataReduction(data) {
this.documentInfo = this.documentInfo.filter(
item =>
`${item.instructionDocNum}-${item.siteCode}` !==
`${data.instructionDocNum}-${data.siteCode}`
);
if (this.documentInfo.length < 1) {
this.showMaterialModal(false);
}
this.insertData = this.insertData.filter(
item => `${item.instructionDocNum}` !== `${data.instructionDocNum}`
);

this.outData = this.outData.filter(
item => `${item.instructionDocNum}` !== `${data.instructionDocNum}`
);
},

change() {
const selectDate = this.dateinfo.slice(0, 10);
const selectHour1 = this.dateinfo.slice(11, 12);
const selectHour2 = this.dateinfo.slice(12, 13);
const selectHour3 = this.dateinfo.slice(11, 13);
if (selectDate === this.minDate) {
if (selectHour1 === 0) {
if (selectHour2 < this.hour) {
this.dateinfo = "";
this.message = "日期不能早于当前日期";
this.show7 = true;
return;
}
} else {
if (selectHour3 < this.hour) {
this.dateinfo = "";
this.message = "日期不能早于当前日期";
this.show7 = true;
return;
}
}
}
if (this.dateinfo) {
let dateObj = new Date(this.dateinfo);

let formattedTime = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1)
.toString()
.padStart(2, "0")}-${dateObj
.getDate()
.toString()
.padStart(2, "0")} ${dateObj
.getHours()
.toString()
.padStart(2, "0")}:${dateObj
.getMinutes()
.toString()
.padStart(2, "0")}:00`;


this.detailData.estimatedArrivalTime = formattedTime;
} else {

this.detailData.estimatedArrivalTime = null;
}
},

showMaterialModal(data, clickFlag) {
if (
!this.secondEditFlag &&
clickFlag === "insert" &&
this.thirdEditFlag
) {
return;
}
if (!this.enableFlag) {
if (this.documentInfo.length > 0) {
this.showHideOnBlur = data;
this.dataFlag = clickFlag;
this.modalList = JSON.parse(JSON.stringify(this.documentInfo));
} else if (
["施工单位-设备类", "施工单位-施工类"].includes(this.detailData.businessType)
) {
if (clickFlag === "insert") {
this.insertData.push({
lineList: [
{
uom: "",
materialName: "",
qty: "",
lineNum: "1"
}
]
});
} else {
this.outData.push({
lineList: [
{
uom: "",
materialName: "",
qty: "",
lineNum: "1"
}
]
});
}
} else {
this.show3 = true;
}
}
},

dataReduction(data) {
this.modalList = this.modalList.filter(
item =>
`${item.instructionDocNum}-${item.siteCode}` !==
`${data.instructionDocNum}-${data.siteCode}`
);
if (this.modalList.length < 1) {
this.showHideOnBlur = false;
}
},

dataLineReduction(index, data) {
this.modalList[index].lineList = this.modalList[index].lineList.filter(
item => item.lineNum !== data.lineNum
);
if (this.modalList[index].lineList.length === 0) {
this.modalList.splice(index, 1);
}
if (this.modalList.length < 1) {
this.showHideOnBlur = false;
}
},

checkMatchingDocs(arr1, arr2) {

for (let doc1 of arr1) {

for (let doc2 of arr2) {

if (
doc1.instructionDocNum === doc2.instructionDocNum &&
(doc1.siteCode === doc2.siteCode || doc1.siteCode === doc2.site)
) {
return true; 
}
}
}
return false; 
},

dataConfirm() {
if (this.dataFlag === "insert") {
if (this.checkMatchingDocs(this.modalList, this.insertData)) {
this.show6 = true;
return;
}

this.modalList.forEach(item => {
this.insertData.push(JSON.parse(JSON.stringify(item)));
});
} else {
if (this.checkMatchingDocs(this.modalList, this.outData)) {
this.show6 = true;
return;
}
this.modalList.forEach(item => {
this.outData.push(JSON.parse(JSON.stringify(item)));
});
}
this.showHideOnBlur = false;
},

handleSearch() {
request("post", `/hitf/v2p/rest/invoke/mateinoutDocQuery`, {
instructionDocNum: this.input1
})
.then(response => {
if (response.data.info !== null) {
this.documentInfo = response.data.info;
} else {
alert(response.data.message);
}
})
.catch(error => {});
},

handleSubmitWait() {
clearTimeout(this.timeout);
this.timeout = setTimeout(() => {
this.handleSubmit();
}, 1000);
},

handleSubmit() {
let list = [];
let idx = 0;
const outRes = this.transformData(this.outData, "OUT", idx);
idx = outRes.nextIndex;
const intoRes = this.transformData(this.insertData, "INTO", idx);
list = outRes.data.concat(intoRes.data);

this.detailData.list = list;

this.detailData.reservationDocStatus = "TO_APPROVE";

if (this.detailData.visitorList.length > 0) {
this.detailData.visitorList = this.detailData.visitorList;
}
if (
["施工单位-设备类", "施工单位-施工类"].includes(this.detailData.businessType) &&
(this.detailData.applicant === "" || !this.detailData.applicant)
) {
this.message = "施工单位对接人未填写，请检查！";
this.show7 = true;
return;
}
if (this.detailData.list.length < 1) {
this.message = "进出厂物资信息未填写，请检查！";
this.show7 = true;
return;
}
if (
this.detailData.type === "VEHICLE" &&
(this.detailData.vehicleCode === "" ||
this.detailData.vehicleCode === null ||
this.detailData.vehicleCode === undefined)
) {
this.message = "车牌信息未填写，请检查！";
this.show7 = true;
return;
}
if (this.detailData.type !== "VEHICLE") {
this.detailData.vehicleCode = this.detailData.driverPhone;
}
if (!this.detailData.driver) {
this.message = "请输入司机姓名";
this.show7 = true;
return;
}
if (!this.detailData.fromOrg) {
this.message = "请输入来访单位";
this.show7 = true;
return;
}
if (!this.detailData.driverIdNumber) {
this.message = "请输入司机身份证号";
this.show7 = true;
return;
}
if (!this.detailData.driverPhone) {
this.message = "请输入司机电话";
this.show7 = true;
return;
}
if (!this.detailData.estimatedArrivalTime) {
this.message = "请选择预计进厂时间";
this.show7 = true;
return;
}
if (!this.detailData.driverGender) {
this.message = "请选择司机性别";
this.show7 = true;
return;
}
if (!this.detailData.siteCode) {
this.message = "请选择工厂";
this.show7 = true;
return;
}
if (!this.detailData.fromOrg) {
this.message = "请输入来访单位";
this.show7 = true;
return;
}
if (!this.detailData.ves) {
this.message = "请选择排放标准";
this.show7 = true;
return;
}
if (!this.detailData.siteCodeMeaning) {
this.message = "请选择工厂";
this.show7 = true;
return;
}
if (!this.detailData.businessType) {
this.message = "请选择预约单类型";
this.show7 = true;
return;
}
if (!this.detailData.type) {
this.message = "请选择预约类型";
this.show7 = true;
return;
}
if (!this.detailData.gate) {
this.message = "请选择门岗";
this.show7 = true;
return;
}
if (!this.detailData.reservationReason) {
this.message = "请输入进出场事由";
this.show7 = true;
return;
}
if (!this.detailData.reservationReason) {
this.message = "请输入进出场事由";
this.show7 = true;
return;
}

const isEditableType = ['施工单位-设备类', '施工单位-施工类'].includes(this.detailData.businessType)


for (let i = 0; i < this.insertData.length; i++) {
const item = this.insertData[i]
if (item.lineList && item.lineList.length > 0) {
for (let j = 0; j < item.lineList.length; j++) {
const lineItem = item.lineList[j]

if (isEditableType) {
if (!lineItem.materialName || lineItem.materialName.trim() === '') {
this.message = `第${i + 1}个进厂物资的物料名称不能为空`
this.show7 = true
return
}
}

if (!lineItem.qty || lineItem.qty.toString().trim() === '' || parseFloat(lineItem.qty) <= 0) {
this.message = `第${i + 1}个进厂物资的数量不能为空且必须大于0`
this.show7 = true
return
}

if (isEditableType) {
if (!lineItem.uom || lineItem.uom.trim() === '') {
this.message = `第${i + 1}个进厂物资的单位不能为空`
this.show7 = true
return
}
}
}
}
}


for (let i = 0; i < this.outData.length; i++) {
const item = this.outData[i]
if (item.lineList && item.lineList.length > 0) {
for (let j = 0; j < item.lineList.length; j++) {
const lineItem = item.lineList[j]

if (isEditableType) {
if (!lineItem.materialName || lineItem.materialName.trim() === '') {
this.message = `第${i + 1}个出厂物资的物料名称不能为空`
this.show7 = true
return
}
}

if (!lineItem.qty || lineItem.qty.toString().trim() === '' || parseFloat(lineItem.qty) <= 0) {
this.message = `第${i + 1}个出厂物资的数量不能为空且必须大于0`
this.show7 = true
return
}

if (isEditableType) {
if (!lineItem.uom || lineItem.uom.trim() === '') {
this.message = `第${i + 1}个出厂物资的单位不能为空`
this.show7 = true
return
}
}
}
}
}

if (
this.checkIdcard(this.detailData.driverIdNumber).valid &&
this.checkphoneNum(this.detailData.driverPhone).valid &&
this.driverName(this.detailData.driver).valid &&
(this.detailData.type === "VEHICLE"
? this.checkCarCode(this.detailData.vehicleCode).valid
: true)
) {
this.detailData.reservationBy = localStorage.getItem("openId");
this.loading = true;
request(
"post",
`/hitf/v2p/rest/invoke/saveMtReservationDoc`,
this.detailData
)
.then(response => {
if (response.data.failed) {
this.loading = false;
this.show5 = true;
} else if (
response.data &&
response.data.code &&
`${response.data.code}` === "1"
) {
this.loading = false;
this.show9 = true;
if (response.data.message) {
this.show9message = response.data.message || "操作失败";
} else {
this.show9message = "操作失败";
}
} else {
this.show4 = true;
setTimeout(() => {
this.loading = false;
this.$router.go(-1);
}, 1000);
}
})
.catch(error => {
this.loading = false;
});
} else {

if (!this.checkIdcard(this.detailData.driverIdNumber).valid) {
this.message = this.checkIdcard(this.detailData.driverIdNumber).msg;
} else if (!this.checkphoneNum(this.detailData.driverPhone).valid) {
this.message = this.checkphoneNum(this.detailData.driverPhone).msg;
} else if (!this.driverName(this.detailData.driver).valid) {
this.message = this.driverName(this.detailData.driver).msg;
} else if (
this.detailData.type === "VEHICLE" &&
!this.checkCarCode(this.detailData.vehicleCode).valid
) {
this.message = this.checkCarCode(this.detailData.vehicleCode).msg;
}

this.show7 = true; 
}
},

handleCancle() {
let list = [];
let idx = 0;
const outRes = this.transformData(this.outData, "OUT", idx);
idx = outRes.nextIndex;
const intoRes = this.transformData(this.insertData, "INTO", idx);
list = outRes.data.concat(intoRes.data);
this.detailData.list = list;
this.detailData.reservationDocStatus = "CANCEL";
this.detailData.reservationBy = localStorage.getItem("openId");
request(
"post",
`/hitf/v2p/rest/invoke/saveMtReservationDoc`,
this.detailData
)
.then(response => {
if (response.data.failed) {
this.show5 = true;
} else {
this.show4 = true;
setTimeout(() => {
location.reload();
}, 1000);
}
})
.catch(error => {
console.error("Error fetching data:", error);
});
},

deleteInsertData(data) {
!this.secondEditFlag && clickFlag === "insert" && this.thirdEditFlag;

if (this.enableFlag || (!this.secondEditFlag && this.thirdEditFlag)) {
return;
}
this.insertData = this.insertData.filter(
item =>
`${item.instructionDocNum}-${item.siteCode}` !==
`${data.instructionDocNum}-${data.siteCode}`
);
},

deleteInsertLineData(index, data) {

if (this.enableFlag || (!this.secondEditFlag && this.thirdEditFlag)) {
return;
}
this.insertData[index].lineList = this.insertData[index].lineList.filter(
item => item.instructionId !== data.instructionId
);
if (this.insertData[index].lineList.length === 0) {
this.insertData.splice(index, 1);
}
},

deleteOutData(data) {
if (this.enableFlag) {
return;
}
this.outData = this.outData.filter(
item =>
`${item.instructionDocNum}-${item.siteCode}` !==
`${data.instructionDocNum}-${data.siteCode}`
);
},

deleteOutLineData(index, data) {
if (this.enableFlag) {
return;
}
this.outData[index].lineList = this.outData[index].lineList.filter(
item => item.instructionId !== data.instructionId
);
if (this.outData[index].lineList.length === 0) {
this.outData.splice(index, 1);
}
},
transformData(inputArray, type, startIndex = 0) {
let lineIndex = startIndex; 
const isYiGong = ['施工单位-设备类', '施工单位-施工类'].includes(this.detailData.businessType);
const data = inputArray
.map(item => {

const instructionDocNum = item.instructionDocNum;
const site = item.site || item.siteCode;
const instructionDocType = item.instructionDocType; 
const instructionDocTypeMeaning = item.instructionDocTypeMeaning; 
const reservationMaterialType = type; 
const supplierCode = item.supplierCode; 
const supplierName = item.supplierName; 
const customerCode = item.customerCode; 
const customerName = item.customerName; 
const contactPersonName = item.contactPersonName; 
const contactPerson = item.contactPerson
? item.contactPerson
: item.creationPerson; // 假设固定值
const instructionNum = item.instructionNum; 


return item.lineList.map((line) => {
if (isYiGong) lineIndex++;
return {
instructionDocNum, // 保持原有的文档编号
site, // 保持原有的站点
instructionDocType, // 固定的文档类型
reservationMaterialType, // 固定的物料类型

materialCode: line.materialCode, // 从 lineList 中获取 materialCode
materialName: line.materialName, // 从 lineList 中获取 materialName
qty: parseFloat(line.qty).toFixed(2), // 将数量转换为数字，保留两位小数
uom: line.uom, // 从 lineList 中获取单位
supplierCode, // 固定值
supplierName, // 固定值
customerCode, // 固定值
customerName, // 固定值
contactPerson, // 固定值
instructionNum: isYiGong
? lineIndex
: (line.instructionNum ? line.instructionNum : line.lineNum),

instructionDocTypeMeaning,
contactPersonName

};
});
})
.flat(); // 使用 flat() 使得每个 lineList 数组扁平化到同一层级
return { data, nextIndex: lineIndex };
},

changefollowerGender(item) {
this.visitorGender = item.value;
this.followerGenderFlag = false;
},

followerCancel() {
this.idNumber = "";
this.visitorPhone = "";
this.visitorName = "";
this.visitorGender = "";
this.followFlag = false;
},

followerConfirm() {
if (!this.idNumber) {
this.message = "请输入随行人身份证号";
this.show7 = true;
return;
}

if (!this.visitorPhone) {
this.message = "请输入随行人电话";
this.show7 = true;
return;
}
if (!this.visitorName) {
this.message = "请输入随行人名称";
this.show7 = true;
return;
}
if (!this.visitorGender) {
this.message = "请选择随行人性别";
this.show7 = true;
return;
}
let data = {};
data.idNumber = this.idNumber;
data.visitorPhone = this.visitorPhone;
data.visitorGender = this.visitorGender;
data.visitorName = this.visitorName;
if (
this.checkIdcard(this.idNumber).valid &&
this.checkphoneNum(this.visitorPhone).valid &&
this.driverName(this.visitorName).valid
) {
this.detailData.visitorList.push(data);
this.idNumber = "";
this.visitorPhone = "";
this.visitorName = "";
this.visitorGender = "";
this.followFlag = false;
} else {
if (!this.checkIdcard(this.idNumber).valid) {
this.message = this.checkIdcard(this.idNumber).msg;
} else if (!this.checkphoneNum(this.visitorPhone).valid) {
this.message = this.checkphoneNum(this.visitorPhone).msg;
} else if (!this.driverName(this.visitorName).valid) {
this.message = this.driverName(this.visitorName).msg;
}
this.show7 = true; 
}
},

deleteFollower(index, item) {
this.visitorList.splice(index, 1);
},

changecategory(item) {
this.detailData.ves = item.value;
this.detailData.vesMeaning = item.meaning;
this.categoryFlag = false;
}
}
};



// WEBPACK FOOTER //
// ./src/views/detail.vue